import { useState } from "react"

/**
 * Bottom-sheet enter/exit animation. The sheet slides up on mount and, on
 * dismiss, slides back down before unmounting — mirroring the open.
 *
 * Returns the enter/exit class pairs for the backdrop and panel plus a `dismiss`
 * helper that plays the slide-out, then runs the caller's close action once it
 * finishes (kept in sync with the 300ms animation).
 */
export function useSheetDismiss() {
  const [closing, setClosing] = useState(false)

  const dismiss = (done: () => void) => {
    if (closing) return
    setClosing(true)
    window.setTimeout(done, 300)
  }

  return {
    closing,
    backdropClass: closing
      ? "animate-out fade-out duration-300 fill-mode-forwards"
      : "animate-in fade-in",
    panelClass: closing
      ? "animate-out slide-out-to-bottom duration-300 fill-mode-forwards"
      : "animate-in slide-in-from-bottom duration-300",
    dismiss,
  }
}
